/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DayOfWeek } from '../models/DayOfWeek';
import type { DeleteDayShiftTemplatesRequestAdmin } from '../models/DeleteDayShiftTemplatesRequestAdmin';
import type { DeleteShiftTemplatesRequestAdmin } from '../models/DeleteShiftTemplatesRequestAdmin';
import type { Pagination1OfShiftTemplateAdminDto } from '../models/Pagination1OfShiftTemplateAdminDto';
import type { PostPutShiftTemplateRequestAdmin } from '../models/PostPutShiftTemplateRequestAdmin';
import type { ShiftTemplateAdminDto } from '../models/ShiftTemplateAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftTemplatesService {
    /**
     * **Required Policy:** `ManageShiftTemplates`
     * @returns ShiftTemplateAdminDto OK
     * @throws ApiError
     */
    public static postShiftTemplateAdmin({
        requestBody,
    }: {
        requestBody?: PostPutShiftTemplateRequestAdmin,
    }): CancelablePromise<ShiftTemplateAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifttemplates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShiftTemplates`
     * @returns Pagination1OfShiftTemplateAdminDto OK
     * @throws ApiError
     */
    public static getShiftTemplatesAdmin({
        dayOfWeek,
        fromStartTimeDayOfWeek,
        fromStartTime,
        toStartTimeDayOfWeek,
        toStartTime,
        fromDuration,
        toDuration,
        regionId,
        minSize,
        maxSize,
        page,
        limit,
    }: {
        dayOfWeek?: DayOfWeek,
        fromStartTimeDayOfWeek?: DayOfWeek,
        fromStartTime?: string,
        toStartTimeDayOfWeek?: DayOfWeek,
        toStartTime?: string,
        fromDuration?: string,
        toDuration?: string,
        regionId?: number,
        minSize?: number,
        maxSize?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShiftTemplateAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shifttemplates',
            query: {
                'dayOfWeek': dayOfWeek,
                'fromStartTimeDayOfWeek': fromStartTimeDayOfWeek,
                'fromStartTime': fromStartTime,
                'toStartTimeDayOfWeek': toStartTimeDayOfWeek,
                'toStartTime': toStartTime,
                'fromDuration': fromDuration,
                'toDuration': toDuration,
                'regionId': regionId,
                'minSize': minSize,
                'maxSize': maxSize,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteShiftTemplates`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteShiftTemplateAdmin({
        requestBody,
    }: {
        requestBody?: DeleteShiftTemplatesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/shifttemplates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShiftTemplateDetails`
     * @returns ShiftTemplateAdminDto OK
     * @throws ApiError
     */
    public static getShiftTemplateAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShiftTemplateAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shifttemplates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShiftTemplates`
     * @returns ShiftTemplateAdminDto OK
     * @throws ApiError
     */
    public static putShiftTemplateAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostPutShiftTemplateRequestAdmin,
    }): CancelablePromise<ShiftTemplateAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/shifttemplates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteShiftTemplates`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDayShiftTemplateAdmin({
        requestBody,
    }: {
        requestBody?: DeleteDayShiftTemplatesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/shifttemplates/day',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
